import { createReducer, on } from '@ngrx/store';
import { initialState, IAuthState } from './auth.state';
import { setAuthError, initAuth, initAuthSuccess, setAuthStep } from './auth.actions';
import { AuthStep } from '@app/core/authentication/enums/auth-step.enum';
import { IAuthErrorResponse } from '@app/api/interfaces/auth.interface';

export const authReducer = createReducer(
  initialState,
  on(
    initAuth,
    (state): IAuthState => ({
      ...state,
      loading: true,
    })
  ),
  on(
    initAuthSuccess,
    (state, action: { step: AuthStep }): IAuthState => ({
      ...state,
      initialized: true,
      loading: false,
      step: action.step,
    })
  ),
  on(
    setAuthStep,
    (state, action: { step: AuthStep; stepData: unknown | null }): IAuthState => ({
      ...state,
      step: action.step,
      stepData: action.stepData,
    })
  ),
  on(
    setAuthError,
    (state, action: { error: IAuthErrorResponse }): IAuthState => ({
      ...state,
      error: action.error,
      loading: false,
    })
  )
);
